import { render } from "./ListeValidationTaskPage.vue?vue&type=template&id=06b19a2c&ts=true"
import script from "./ListeValidationTaskPage.vue?vue&type=script&lang=ts"
export * from "./ListeValidationTaskPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__